<div id="google_translate_element"></div>
<app-script-loader scriptText="{{ gFunction }}"></app-script-loader>
<app-script-loader src="{{ gStript }}"></app-script-loader>
<app-script-loader scriptText="{{ styleScriptWidget }}"></app-script-loader>
